import { useRef, useState } from 'react';

import {
  ISelectorMenuItem,
  IUseSelectorPresenter,
  ISelectorPresenter,
  ISelectorPresenterParams,
} from './Selector.types';

export function useSelectorPresenter<K extends string>(
  params: ISelectorPresenterParams<K>
): IUseSelectorPresenter {
  const { value, items, isDisabled, onChange, emptyLabel } = params;

  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isOpened, setIsOpened] = useState(false);
  const presenter: ISelectorPresenter = {
    isOpened,

    get menuItems(): ISelectorMenuItem[] {
      return items.map((item) => ({
        ...item,
        isDisabled: isDisabled,
        isSelected: item.key === value,
        onClick: presenter.onItemClick,
      }));
    },

    get buttonLabel(): string {
      return items.find((item) => item.key === value)?.title || emptyLabel || 'Select';
    },

    onItemClick(key: K): void {
      onChange(key);
      presenter.onClose();
    },

    toggleIsOpened(): void {
      setIsOpened((currentIsOpened) => !currentIsOpened);
    },

    onClose(): void {
      setIsOpened(false);
    },
  };

  return { buttonRef, presenter };
}
